/**
 * PATH: packages/job-hub/src/jobs/jobRowMenu/statusOptions.ts
 * FILE_ID: JOBHUB-JOBROWMENU-STATUS-001
 * PURPOSE: Canonical status choices and their menu icons.
 * WHY: Status consumers share one ordered public option list.
 */
import {
  CheckCircle2,
  Circle,
  PlayCircle,
  XCircle,
} from 'lucide-react'

/** Operator-facing job lifecycle states (excludes `archived`, which
 * has its own dedicated entry, and `prospect`, which lives in Quote
 * Tracking). Order is the canonical happy-path flow.
 *
 * LANDMINE: the labels are the DONOR's, transplanted from StatFormat's
 * status option list in src/Pages/Components/utils/statFormatComponents.jsx.
 * They are not free-form prose. `wip` reads "Active Works" and not "Work in
 * progress" because that is the phrase Bravada estimators use, and the same
 * four words appear on the status filter chips — a pill saying "Work in
 * progress" under a chip saying "Active Works" reads as two different states.
 * Do not "tidy" these into sentence case.
 */
export const JOB_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'tbc', label: 'Inactive' },
  { value: 'wip', label: 'Active Works' },
  { value: 'done', label: 'Completed' },
  { value: 'bin', label: 'Archive' },
]

/** Tiny visual cue per status key — keeps the Set status submenu scannable. */
export function statusIconFor(status: string) {
  switch (status) {
    case 'tbc': return Circle
    case 'wip': return PlayCircle
    case 'done': return CheckCircle2
    case 'bin': return XCircle
    default: return Circle
  }
}
